import React, { useState, useEffect } from "react";

const SunIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

const MoonIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const ThemeToggle = ({ currentTheme, onToggleTheme }) => {
  const isDark = currentTheme === 'darkTheme';
  const [animating, setAnimating] = useState(false);
  const [showIcon, setShowIcon] = useState(isDark ? 'sun' : 'moon');

  useEffect(() => {
    setShowIcon(isDark ? 'sun' : 'moon');
  }, [isDark]);

  const handleClick = () => {
    if (animating) return;
    setAnimating(true);

    // After the current icon exits (slides down), swap and enter the new one (slides up)
    setTimeout(() => {
      onToggleTheme();
      setTimeout(() => setAnimating(false), 200);
    }, 150);
  };

  // Current icon exits downward, new icon enters from above
  const exitDown = animating && showIcon === (isDark ? 'sun' : 'moon');
  const enterUp = animating && showIcon !== (isDark ? 'sun' : 'moon');

  return (
    <button
      onClick={handleClick}
      className="ml-4 p-2 rounded-full hover:bg-bg-body3 text-txt-contrast relative overflow-hidden w-9 h-9 flex items-center justify-center"
      aria-label="Toggle theme"
    >
      <span
        className="absolute transition-all duration-200 ease-in-out flex items-center justify-center"
        style={{
          transform: exitDown ? 'translateY(24px) rotate(90deg)' : enterUp ? 'translateY(-24px) rotate(-90deg)' : 'translateY(0) rotate(0deg)',
          opacity: exitDown ? 0 : enterUp ? 0 : 1,
        }}
      >
        {showIcon === 'sun' ? <SunIcon /> : <MoonIcon />}
      </span>
    </button>
  );
};

const Navigation = ({ currentTheme, onToggleTheme }) => {
  return (
    <nav className="hidden md:flex sticky top-0 z-[3] flex-row justify-between items-center backdrop-blur-[12px] bg-bg-body2/[0.58] transition-all duration-theme ease-theme px-6">
      <a href="#home" className="text-primary-main font-bold text-lg">{`<pkaya/>`}</a>
      <div className="flex items-center">
        <ul className="p-0 m-0 flex flex-row justify-center font-medium">
          <li><a className="p-5 inline-block transition-all duration-theme ease-theme text-txt-contrast hover:text-primary-main" href="#home">Home</a></li>
          <li><a className="p-5 inline-block transition-all duration-theme ease-theme text-txt-contrast hover:text-primary-main" href="#exp">Experience</a></li>
          <li><a className="p-5 inline-block transition-all duration-theme ease-theme text-txt-contrast hover:text-primary-main" href="#projects">Projects</a></li>
          <li><a className="p-5 inline-block transition-all duration-theme ease-theme text-txt-contrast hover:text-primary-main" href="#about">About</a></li>
          <li><a className="p-5 inline-block transition-all duration-theme ease-theme text-txt-contrast hover:text-primary-main" href="#contact">Contact</a></li>
        </ul>
        <ThemeToggle currentTheme={currentTheme} onToggleTheme={onToggleTheme} />
      </div>
    </nav>
  );
};

export default Navigation;
